import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const Features = () => {
    const apiService = new LeaseApiService();
    const { currencyPrecision } = useCurrency();

    return (
        <div className='p-3'>

        </div>

    );
};
export default Features;